import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    height: 1,
    backgroundColor: props.color ? props.color : theme.white,
    margin: "8px 0 8px 0",
    padding: 0,
    width: "100%",
  }),
}));
export const Seperator = (props) => {
  const classes = useStyles(props);

  return (
    <>
      <Box className={classes.root}></Box>
      {/* <div className={classes.root}></div> */}
    </>
  );
};

Seperator.propTypes = {
  color: PropTypes.string,
};

export default Seperator;
